import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';

export const I_PAGE_VISIBILITY_SERVICE = new InjectionToken<IPageVisibilityService>('IPageVisibilityService');
export interface IPageVisibilityService {
  isVisible: Observable<boolean>;
}
